import { WidgetPieNumeric } from '../Widgets';
import { connect } from 'react-redux';
import { getConversionDrillData } from '../../redux/actions/conversion';
import { getSubMethodLookupData } from '../../redux/actions/subs';

const mapStateToProps = (state, ownProps) => ({
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.conversion.drillData && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.drillData.filter(item => item._id).map(item => ({
    value: (item[ownProps.filters.series] / item.nv) * 100,
    key: (state.subs.lookupData && ownProps.filters.param === 'partnerId') ?
          (state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param])).length !== 0 ? state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param]))[0].value : '') : item[ownProps.filters.param]
  })) : [],
  infoItems: state.conversion.drillData && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.drillData.filter(item => item._id).map(item => ({
    amount: (item[ownProps.filters.series] / item.nv) * 100,
    description: (state.subs.lookupData && ownProps.filters.param === 'partnerId') ?
          (state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param])).length !== 0 ? state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param]))[0].value : '') : item[ownProps.filters.param]
  })) : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz,
    ...ownProps.filters
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.conversion.drillLoaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate
    && ownProps.filters.param
    && ownProps.filters.date,
  loaded: state.conversion.drillLoaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate
    && ownProps.filters.param
    && ownProps.filters.date,
  close: ownProps.close
})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, graphId) => {
    dispatch(getConversionDrillData(params, graphId));
    if(params.param === "partnerId") dispatch(getSubMethodLookupData(params, graphId));
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WidgetPieNumeric)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetPieDrillConversionConnected.js